import { render } from "./index.vue?vue&type=template&id=95850cdc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=95850cdc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95850cdc"],['__file',"src/common/components/BaseBadges/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95850cdc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95850cdc', __exports__)) {
    api.reload('95850cdc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=95850cdc&scoped=true", () => {
    api.rerender('95850cdc', render)
  })

}


export default __exports__